import React from 'react';
import { useLanguage } from './index';
import styles from './LangDebugSpan.module.css';

interface LangDebugSpanProps {
  langKey: string;
  value: string;
}

/**
 * Wraps a translated string with a highlighted badge showing its key.
 * Only renders when ?showlang=true in URL and user is superadmin.
 * Clicking the key badge opens the Language Editor at that key.
 */
export const LangDebugSpan: React.FC<LangDebugSpanProps> = ({ langKey, value }) => {
  const { locale } = useLanguage();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const url = `/admin/platform/language-settings/${locale}?focus=${encodeURIComponent(langKey)}`;
    window.open(url, '_blank');
  };

  return (
    <span className={styles.debugWrapper}>
      <span className={styles.debugValue}>{value}</span>
      <button
        className={styles.debugBadge}
        onClick={handleClick}
        title={`Click to edit this string in Language Editor`}
        type="button"
      >
        🔑 {langKey}
      </button>
    </span>
  );
};
